(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[28512],{

/***/ 46383:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topclinicaltrials",
      function () {
        return __webpack_require__(4372);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ TopClinicalTrialsHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_topclinicaltrials_mainBanner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56723);
/* harmony import */ var _components_layouts_topClinicalTrialsWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8610);
/* harmony import */ var _components_topclinicaltrials_discoverTheBenefits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34531);
/* harmony import */ var _components_topclinicaltrials_personalizedMatching__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32963);
/* harmony import */ var _components_topclinicaltrials_comprehensiveSupport__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44716);
/* harmony import */ var _components_topclinicaltrials_advancedTechnology__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15528);
/* harmony import */ var _components_topclinicaltrials_expertCareComprehensiveHealth__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24743);
/* harmony import */ var _components_topclinicaltrials_matchTrialsAndWhyTrialsContainer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6773);
/* harmony import */ var _components_topclinicaltrials_getStartedToday__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(65144);










var __N_SSP = true;
function TopClinicalTrialsHome() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layouts_topClinicalTrialsWrapper__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        whiteLogo: true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_topclinicaltrials_mainBanner__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_topclinicaltrials_discoverTheBenefits__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_topclinicaltrials_personalizedMatching__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_topclinicaltrials_comprehensiveSupport__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_topclinicaltrials_advancedTechnology__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_topclinicaltrials_expertCareComprehensiveHealth__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_topclinicaltrials_matchTrialsAndWhyTrialsContainer__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_topclinicaltrials_getStartedToday__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [92592,10621,12672,8610,51603,49774,92888,40179], function() { return __webpack_exec__(46383); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);